import { KeyValue } from '@/main/models/common';
import {
  DomainUsersByCompanyActionTypes,
  DomainUsersByCompanyTypes
} from './domainUsersByCompanyTypes';

export function getDomainUsersByCompany(
  guidCompany: string
): DomainUsersByCompanyActionTypes {
  return {
    type: DomainUsersByCompanyTypes.GET_DOMAIN_USERS_BY_COMPANY,
    payload: guidCompany
  };
}

export function saveDomainUsersByCompany(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): DomainUsersByCompanyActionTypes {
  return {
    type: DomainUsersByCompanyTypes.SAVE_DOMAIN_USERS_BY_COMPANY,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerDomainUsersByCompany(): DomainUsersByCompanyActionTypes {
  return {
    type: DomainUsersByCompanyTypes.RESET_REDUCER_DOMAIN_USERS_BY_COMPANY
  };
}
